"use strict";
exports.__esModule = true;
exports.Compactor = exports.Compactable = void 0;
var Compactable = /** @class */ (function () {
    function Compactable() {
        this.optimistic = false;
        /// This should be true only if the reducer is commutative and idempotent.
        this.crdt = false;
    }
    Compactable.prototype.unpackState = function (state) {
        return state;
    };
    Compactable.prototype.packState = function (state) {
        return state;
    };
    return Compactable;
}());
exports.Compactable = Compactable;
var Compactor = /** @class */ (function () {
    function Compactor(opts) {
        this.compactable = opts.compactable;
        var state = this.compactable.initialState();
        this.lastConfirmedState = null;
        this.state = state;
        this.lastConfirmedSeq = 0;
        this.db = opts.db;
        this.randId = Math.random().toString(36).substring(7);
        this.key = opts.key;
        this.callback = opts.callback;
        this.sizeThreshold = opts.sizeThreshold || 30;
        this.onSequenceValue = this.onSequenceValue.bind(this);
        this.onSize = this.onSize.bind(this);
        this.dispatch = this.dispatch.bind(this);
    }
    Compactor.prototype.maybeClone = function (state) {
        if (this.compactable.crdt) {
            return state;
        }
        else {
            return structuredClone(state);
        }
    };
    Compactor.prototype.subscribe = function () {
        this.lastConfirmedState = this.maybeClone(this.state);
        this.db.subscribe(this.key, this.onSequenceValue, this.onSize);
    };
    Compactor.prototype.destroy = function () {
        this.db.unsubscribe(this.key, this.onSequenceValue, this.onSize);
    };
    Compactor.prototype.dispatch = function (action) {
        this.db.send({
            type: 'push',
            action: { type: 'append' },
            value: { apply: action, i: this.randId },
            key: this.key
        });
        if (this.compactable.optimistic) {
            this.state = this.compactable.applyAction(this.state, action);
            this.callback(this.state);
        }
    };
    Compactor.prototype.onSequenceValue = function (sequenceValue) {
        if (sequenceValue.seq <= this.lastConfirmedSeq) {
            return;
        }
        var value = sequenceValue.value;
        if (value.reset !== undefined) {
            this.lastConfirmedState = this.compactable.unpackState(value.reset);
            this.lastConfirmedSeq = sequenceValue.seq;
            this.state = this.maybeClone(this.lastConfirmedState);
            this.callback(this.state);
            return;
        }
        if (value.apply !== undefined) {
            this.lastConfirmedState = this.compactable.applyAction(this.lastConfirmedState, value.apply);
            this.lastConfirmedSeq = sequenceValue.seq;
            if (value.i !== this.randId || !this.compactable.optimistic) {
                this.state = this.maybeClone(this.lastConfirmedState);
                this.callback(this.state);
            }
            return;
        }
        console.log('Unknown message', sequenceValue.value);
    };
    Compactor.prototype.onSize = function (size) {
        var _a;
        if (size > this.sizeThreshold && this.lastConfirmedSeq !== 0) {
            var newState = this.compactable.packState(this.lastConfirmedState);
            (_a = this.db) === null || _a === void 0 ? void 0 : _a.send({
                type: 'push',
                action: { type: 'compact', seq: this.lastConfirmedSeq },
                value: { reset: newState },
                key: this.key
            });
        }
    };
    return Compactor;
}());
exports.Compactor = Compactor;
